export default __webpack_public_path__ + "static/media/mongodb-logo.153b7b44.svg";